<template>
  <div class="bottom_container">
    <div class="redeem_head_container">
      <!--  -->
      <div class="company_status_container">
        <div class="company">{{couponObj.company}}</div>
        <div>
          <div class="coupon_status_did_usered" v-if="couponObj.status == 'ISSUED'">Pending</div>
          <div class="coupon_status_did_deprecated" v-if="couponObj.status == 'EXPIRY'">Expired</div>
          <div class="coupon_status_did_usered" v-if="couponObj.status == 'REDEEMED'">Used</div>
          <div class="coupon_status_did_usered" v-if="couponObj.status == 'OFFERED'">To be used</div>
        </div>
      </div>
      <!-- 多少钱 -->
      <div class="amount">${{couponObj.amount}}</div>
      <div class="coupon_service_name">{{couponObj.service_item}}</div>
    </div>
    <!-- 选择选项 -->
    <div class="select_option_items">
      <div class="one_option_item" v-for="(item,i) in selectOptionItems" v-bind:key="i">
        <div class="title">{{item.title}}</div>
        <input v-if="item.id==3" type="password" v-model="password" />

        <div
          @click="clickPullDown(item)"
          :class="item.isCanSelect?'pull_select_container':'pull_select_container_no_select'"
          v-else
        >
          <div class="select_value">{{item.content}}</div>
          <div class="triangle"></div>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="redeem_button_container">
        <div
          v-if="couponObj.status == 'OFFERED' && clinicId>0 && serviceItemId>0 && password.length>0"
          @click="clickReddemCoupon"
        >Redeem</div>
        <div v-else style="background:rgba(176,171,171,1); opacity: 0.3;">Redeem</div>
      </div>
    </div>

    <!-- 遮罩层选项 -->
    <div v-if="popMaskType != 0" class="mask_list_container" @click="clickMaskView">
      <div class="item_list_container" @click.stop="clickItemContainer">
        <div
          class="one_item"
          v-for="(item,i) in itemsListArray"
          v-bind:key="i"
          @click="clickListItem(item)"
        >
          <div v-for="(oneItem,i) in item.itemArray" v-bind:key="i" class="item_one_item_contianer">
            <div class="type_title_container" v-if="oneItem.title.length>0">
              <div class="point"></div>
              <div class="type">{{oneItem.title}}:</div>
            </div>
            <div class="text_container">
              <div
                class="text"
                v-for="(sutTitle,i) in oneItem.subTitleItems"
                v-bind:key="i"
              >{{sutTitle}}</div>
            </div>
          </div>
          <img
            v-if="item.isSelected"
            class="selected_item_image"
            src="../assets/select_item.png"
            alt
          />
          <div class="undline"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "redeem-coupon",
  data() {
    return {
      token: "",
      couponObj: {},
      selectOptionItems: [
        { title: "Center code", id: 1, content: "", isCanSelect: true },
        { title: "Service Items", id: 2, content: "", isCanSelect: false },
        { title: "Password", id: 3, content: "", isCanSelect: true }
      ],
      popMaskType: 0,
      serviceItemsArray: [],
      itemsListArray: [],
      centerItemArray: [],
      clinicId: 0,
      serviceItemId: 0,
      password: ""
    };
  },

  mounted() {
    this.token = this.$route.params.token;

    this.fetchCouponInfo();
  },
  methods: {
    //加载优惠卷信息
    fetchCouponInfo() {
      this.$get(
        "/mp/coupon/information",
        { token: this._data.token },
        this,
        {}
      ).then(data => {
        this.couponObj = data.coupon;
      });
    },

    //点击开始选择
    clickPullDown(item) {
      if (!item.isCanSelect) {
        return;
      }
      this.popMaskType = item.id;
      this.itemsListArray = [];
      if (this.popMaskType == 1) {
        //加载诊所列表
        this.fetchClinicList();
      }
      if (this.popMaskType == 2) {
        this.setupServiceItem();
      }
    },
    fetchClinicList() {
      if (this.centerItemArray.length > 0) {
        this.setupSelectCenter();
        return;
      }
      // 加载服务诊所列表
      this.$get("/mp/coupon/coupon_clinic", {}, this, {}).then(data => {
        var centerItemArray = [];
        for (let index in data.couponClinic) {
          let model = data.couponClinic[index];

          let clickNameModel = { title: "", subTitleItems: [] };

          for (let newIndex in model.translations) {
            let newModel = model.translations[newIndex];
            switch (newModel.locale) {
              case "en":
                clickNameModel.enName = newModel.name;
                break;
              case "zh-Hant":
                clickNameModel.hantName = newModel.name;
                break;
              default:
                break;
            }
          }
          clickNameModel.subTitleItems.push(clickNameModel.enName);
          clickNameModel.subTitleItems.push(clickNameModel.hantName);

          let result = { itemArray: [clickNameModel] };
          result.clinicCode = model.code;
          result.itemId = model.code;
          result.clinicId = model.id;
          result.couponItems = model.coupon_item;
          centerItemArray.push(result);
        }
        this.centerItemArray = centerItemArray;
        this.setupSelectCenter();
      });
    },

    //设置已经选择了某一个
    setupSelectCenter() {
      for (let index in this.centerItemArray) {
        let model = this.centerItemArray[index];

        model.isSelected = model.clinicCode == this.clinicCode;
      }
      this.itemsListArray = [];
      this.itemsListArray = this.centerItemArray;
    },

    setupServiceItem() {
      this.itemsListArray = this.serviceItemsArray;
    },

    // 点击列表的item
    clickListItem(item) {
      let currentId = item.itemId;
      var contentText = "";
      if (this.popMaskType == 1) {
        contentText = currentId;
        this.clinicId = item.clinicId;
      }
      if (this.popMaskType == 2) {
        contentText = item.name;
        this.serviceItemId = currentId;
      }

      for (let index in this.itemsListArray) {
        let model = this.itemsListArray[index];
        model.isSelected = model.itemId == currentId;

        if (this.popMaskType == 1 && model.isSelected) {
          // 设置诊所对应的服务项

          var serviceItemsArray = [];
          for (let index in model.couponItems) {
            let couponModel = model.couponItems[index];

            let clickNameModel = {
              title: "centre",
              subTitleItems: [couponModel.name]
            };
            let serviceModel = { title: "Service", subTitleItems: [] };

            for (let newIndex in couponModel.translations) {
              let newModel = couponModel.translations[newIndex];

              switch (newModel.locale) {
                case "en":
                  serviceModel.enName = newModel.name;
                  break;
                case "zh-Hant":
                  serviceModel.hantName = newModel.name;
                  break;
                default:
                  break;
              }
            }
            serviceModel.subTitleItems.push(serviceModel.enName);
            serviceModel.subTitleItems.push(serviceModel.hantName);

            let result = { itemArray: [serviceModel, clickNameModel] };
            result.itemId = couponModel.id;
            result.name = couponModel.name;
            serviceItemsArray.push(result);
          }

          this.serviceItemsArray = serviceItemsArray;
        }
      }
      let tempDataArray = this.itemsListArray;
      this.itemsListArray = [];
      this.itemsListArray = tempDataArray;

      var that = this;
      setTimeout(() => {
        for (let index in that.selectOptionItems) {
          let model = that.selectOptionItems[index];
          if (that.popMaskType == 1) {
            model.content = "";
          }
          model.isCanSelect = true;
          if (model.id == that.popMaskType) {
            model.content = contentText;
          }
        }

        let tempArray = that.selectOptionItems;
        that.selectOptionItems = [];
        that.selectOptionItems = tempArray;
        that.popMaskType = 0;
        that.clinicCode = currentId;
      }, 500);
    },
    clickMaskView() {
      this.popMaskType = 0;
    },
    clickItemContainer() {},
    // 点击使用优惠卷
    clickReddemCoupon() {
      this.$post(
        "/mp/coupon/redeemed",
        {
          token: this.token,
          coupon_clinic_id: this.clinicId,
          coupon_item_id: this.serviceItemId,
          password: this.password
        },
        this,
        {}
      ).then(data => {
        if (data.success) {
          this.$toasted.show("OK", {
            theme: "bubble",
            position: "top-left",
            duration: 4000,
            fullWidth: true
          });
          this.fetchCouponInfo();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../style/wellness-coupon.css";
@import "../../style/redeem-coupon.css";

</style>



// WEBPACK FOOTER //
// src/components/redeem-coupon.vue